import { render, staticRenderFns } from "./CabreroCargador.vue?vue&type=template&id=01968ddf&scoped=true&"
import script from "./CabreroCargador.vue?vue&type=script&lang=js&"
export * from "./CabreroCargador.vue?vue&type=script&lang=js&"
import style0 from "./CabreroCargador.vue?vue&type=style&index=0&id=01968ddf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01968ddf",
  null
  
)

export default component.exports